import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { COLORS3 as COLORS, FONT, MEDIA_QUERY, SPACING } from '@zola/zola-ui/src/styles/emotion';
import { COLORS_BUTTONS } from '@zola/zola-ui/src/styles/emotion/colors3';

export const highlightBackground = css`
  background-color: ${COLORS_BUTTONS.WINE_005};
`;

export const desktopOnly = css`
  ${MEDIA_QUERY.EXCLUDE_DESKTOP} {
    display: none;
  }
`;

export const Matrix = styled.div`
  padding: ${SPACING.MD} ${SPACING.MD} 0;
  table-layout: fixed;
  text-align: center;

  ${MEDIA_QUERY.EXCLUDE_MOBILE} {
    padding: 0;
  }
`;

export const MatrixTitle = styled.h1`
  font-family: ${FONT.FONT_FAMILY_CIRCULAR};
  font-size: ${FONT.FONT_SIZE_LARGER};
  font-weight: ${FONT.FONT_WEIGHT_MEDIUM};
  letter-spacing: -0.04em;
  line-height: 125%;
  margin-bottom: ${SPACING.SM};
  text-align: center;
`;

export const Subheader = styled.p`
  color: ${COLORS.BLACK_075};
  font-size: ${FONT.FONT_SIZE_SMALL};
  line-height: 150%;
  margin: 0 0 ${SPACING.S32};
`;

export const Disclaimer = styled.p`
  color: ${COLORS.BLACK_075};
  font-size: ${FONT.FONT_SIZE_SMALLER};
  line-height: ${FONT.FONT_SIZE_REGULAR};
  margin: 0;
`;

export const TableWrapper = styled.div`
  ${MEDIA_QUERY.EXCLUDE_DESKTOP} {
    overflow-x: scroll;
    overflow-y: hidden;
    -webkit-overflow-scrolling: touch;
  }
`;

export const MatrixTable = styled.div`
  border-collapse: collapse;
  display: table;
  margin: 0 auto ${SPACING.S24} auto;
  width: 690px;

  ${MEDIA_QUERY.DESKTOP} {
    width: 877px;
  }
`;

export const MatrixColgroup = styled.div`
  display: table-column-group;
`;

export const MatrixColumn = styled.div`
  display: table-column;
`;

export const MatrixTableRow = styled.div`
  display: table-row;
  gap: ${SPACING.SM};
  padding: ${SPACING.XS} 0px;
`;

export const BorderedRow = styled(MatrixTableRow)`
  border-color: ${COLORS.BLACK_030};
  border-style: solid;
  border-width: 1px 0px;
`;

export const MatrixTableTitleCell = styled.div`
  display: table-cell;
  left: 0;
  max-width: 87px;
  padding-bottom: ${SPACING.S24};
  text-align: center;
  z-index: 1;

  ${MEDIA_QUERY.DESKTOP} {
    left: unset;
    max-width: 116px;
  }
`;

export const CellTitle = styled.p`
  color: ${COLORS.BLACK_075};
  font-size: ${FONT.FONT_SIZE_SMALL};
  font-weight: ${FONT.FONT_WEIGHT_SEMI_BOLD};
  line-height: ${FONT.FONT_SIZE_LARGE};
  margin: 0;
`;

export const PageCount = styled(CellTitle)<{ isHighlightedCell: boolean }>`
  color: ${COLORS.BLACK_100};

  ${({ isHighlightedCell }) =>
    isHighlightedCell &&
    `
      color: ${COLORS.WINE_100};
  `};
`;

export const CellSubtitle = styled.p`
  color: ${COLORS.BLACK_075};
  font-size: ${FONT.FONT_SIZE_SMALLER};
  line-height: ${FONT.FONT_SIZE_REGULAR};
  margin: 0;
`;

export const PopularCellTitle = styled(CellSubtitle)`
  color: ${COLORS.WHITE_100};
`;

export const CountSubtitle = styled(CellSubtitle)`
  color: ${COLORS.WINE_100};
  font-size: ${FONT.FONT_SIZE_EXTRA_SMALL};
`;

export const IconWrapper = styled.div`
  height: 81px;
  margin: ${SPACING.XS} 0 ${SPACING.SM};
  position: relative;
`;

export const AlbumIcon = styled.img`
  bottom: 0;
  left: 50%;
  position: absolute;
  transform: translateX(-50%);
`;

export const MatrixTableCell = styled.div<{ isDoubleHighlighted?: boolean; isTaller?: boolean }>`
  background-color: ${({ isDoubleHighlighted }) =>
    isDoubleHighlighted ? `${COLORS_BUTTONS.WINE_015}` : 'unset'};
  display: table-cell;
  height: ${({ isTaller }) => (isTaller ? '58px' : '48px')};
  max-width: 120px;
  padding: 0 ${SPACING.MD};
  vertical-align: middle;
  width: fit-content;
`;

export const PageCountCell = styled(MatrixTableCell)`
  text-align: left;
`;

export const ShorterCell = styled(MatrixTableCell)`
  height: 28px;
`;

export const PopularCell = styled(ShorterCell)`
  background-color: ${COLORS.WINE_100};
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  padding: ${SPACING.XXS} 0;
`;

export const CellInfo = styled.p<{ isHighlightedCell: boolean }>`
  color: ${COLORS.BLACK_075};
  font-size: ${FONT.FONT_SIZE_SMALL};
  line-height: ${FONT.FONT_SIZE_LARGE};
  margin: 0;

  ${({ isHighlightedCell }) =>
    isHighlightedCell &&
    `
      color: ${COLORS.WINE_100};
      font-weight: ${FONT.FONT_WEIGHT_SEMI_BOLD};
  `};
`;
